import { actionTypes, mutationTypes, getterTypes } from "./types";
import _service from "../api";

const actions = {
  async [actionTypes.FETCH_CATEGORY]({ commit, getters }) {
    if (getters[getterTypes.GET_CATEGORY].length == 0) {
      const { data } = await _service.fetchCategory();
      if (data) {
        commit(mutationTypes.SET_CATEGORY, data);
      }
    }
  },
  async [actionTypes.FETCH_ROL]({ commit, getters }) {
    if (getters[getterTypes.GET_ROL].length == 0) {
      const { data } = await _service.fetchRol();
      if (data) {
        commit(mutationTypes.SET_ROL, data);
      }
    }
  },
  async [actionTypes.FETCH_EVENT_BY_ID](_, { id }) {
    const { data } = await _service.fetchEventById(id);
    return data;
  },
  async [actionTypes.DELETE_EVENT](_, { id }) {
    const { data } = await _service.deleteEvent(id);
    return data;
  },
  async [actionTypes.SAVE_CHANGES](_, { formData, isEditMode }) {
    if (isEditMode) {
      return await _service.updateEvent(formData);
    } else {
      return await _service.saveEvent(formData);
    }
  },
  async [actionTypes.FETCH_EVENTS]({ commit }, { categoryId, applicationId }) {
    const { data } = await _service.fetchEvents(categoryId, applicationId);
    if (data) {
      commit(mutationTypes.SET_EVENTS, data);
    }
  },
};

export default actions;
